import ApiCore from "./api_core";
import { NewGlobalPropertyI } from "./types";

export default new class {
    get(property: string) {
        return ApiCore.getJson<Record<string, string>>('global_properties', { property })
    }

    set(property: string, propertyValue: string) {
        return ApiCore.postJson<NewGlobalPropertyI>('global_properties', {
            property, property_value: propertyValue
        })
    }

    async isProp(property: string) {
        try {
            const [prop, val] = property.split('=')
            const curVal = await this.get(prop)

            if (curVal?.data) return val === curVal.data[prop]
        } catch (e) {
            console.error(e)
        }
        return false
    }
}